import Backbone from 'backbone'
import template from './panels-lists-tables.hbs'
import DraggableList from 'draggable-list'
import Collapsible from 'scoreboard/components/collapsible'
import AlertList from 'scoreboard/home/alerts/alert-list'
import alerts from './alerts.json'
import SortableTable from 'scoreboard/components/sortable-table-view'
import sortableTableTbody from './sorted-table-tbody.hbs'
import CollapsibleGroup from 'scoreboard/components/collapsible-group'
import _ from 'lodash'
import valuesFormModel from './values-form-model'
import ValuesForm from 'scoreboard/scorecards/overview/values-form'
import icon from 'scoreboard/components/icon'

var FormControls = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-panels-lists-tables',

	render: function () {
		let genericTableRows = [{
			cells: [{
				title: 'One'
			},{
				title: 'Two'
			},{
				title: 'Three'
			}]
		},{
			cells: [{
				title: 'Four'
			},{
				title: 'Five'
			},{
				title: 'Six'
			}]
		},{
			cells: [{
				title: 'Seven'
			},{
				title: 'Eight'
			},{
				title: 'Nine'
			}]
		}]

		this.$el.empty().append(template({
			emptyPanelMessage: 'This is an empty panel message',
			genericList: [{
				title: 'Title',
				subtitle: 'Subtitle'
			},{
				title: 'Title',
				subtitle: 'Subtitle'
			},{
				title: 'Really long title that\'s really long and cumbersome and will likely overflow in order to show what happens when titles are way too long',
				subtitle: 'Really long subtitle that\'s really long and cumbersome and will likely overflow in order to show what happens when titles are way too long'
			}],
			genericTableRows,
		}))
		new DraggableList(this.$('.draggable-list')[0])
		// Set up collapsible panel
		this.$('.collapsible-panel').append(new Collapsible({
			header: `<span class='toggler'>${icon('collapsed')}</span><h3>Collapsible panel this is a long title in order to test out what happens when this is the case</h3>`,
			content: '<div style="height:100px;">This is the collapsible panel body</div>',
			collapsed: false
		}).render().el)
		// Set up alert list
		this.alertList = new AlertList({
			data: alerts
		})
		this.$('.alert-list').replaceWith(this.alertList.el)
		this.alertList.render()

		this.sortedData = [
			{id: 3, title: 'Yankee', price: 4.89},
			{id: 1, title: 'Zulu', price: 15.56},
			{id: 2, title: 'X-ray', price: 6.22}
		]
		// Create the sortable table
		new SortableTable({
			el: this.$('.sortable-table-test'),
			defaultSortField: 'title',
			data: this.sortedData,
			fields: ['id', 'title', 'price']
		}).on('sorted', data => {
			this.sortedData = data
			this.$('.sortable-table-test tbody').html(sortableTableTbody(this))
		}).applySort()

		// Create the collapsible group example with three test views to go in it
		this.collapsibleGroup = new CollapsibleGroup()
		var view1 = new Collapsible({
			header: '<h3>Collapsible Group PANEL1</h3>',
			content: '<div>content</div>',
			collapsed: true
		})
		this.collapsibleGroup.add(view1)
		var view2 = new Collapsible({
			header: '<h3>Collapsible Group PANEL2</h3>',
			content: '<div>content</div>',
			collapsed: true
		})
		this.collapsibleGroup.add(view2)
		var view3 = new Collapsible({
			header: '<h3>Collapsible Group PANEL2</h3>',
			content: '<div>content</div>',
			collapsed: true
		})
		this.collapsibleGroup.add(view3)
		this.$('.collapsible-group').append(view1.el)
		view1.render()
		this.$('.collapsible-group').append(view2.el)
		view2.render()
		this.$('.collapsible-group').append(view3.el)
		view3.render()

		// Create the values form with test data
		var valuesForm = new ValuesForm({
			model: valuesFormModel,
			guard: false
		})

		this.$('.values-form-container').append(valuesForm.el)
		valuesForm.render()
		// nix the dialog-body-content class to get rid of dialog styling here
		// so we can focus on the table itself for testing purposes.
		valuesForm.$('.dialog-body-content').removeClass()



		// TODO: This pagination table takes a whole time to load and slows down the page.
		// It slows down the ui tests a lot. We should place this behind a button to activate it.


		// // create another table fo the pagination example
		// let data = []
		// for (var i = 0; i < 200000; i++) {
		// 	data.push({
		// 		id: i,
		// 		title: `title-${i}`,
		// 		price: `$${i}`
		// 	})
		// }

		// let paginationTable = this.$('.test-pagination-table .table')
		// paginationTable.find('tbody').append(sortableTableTbody({data}))

		// let toggleDots = show => {
		// 	panelContent.css({
		// 		'min-height': show ? panelContent.height() : null,
		// 		'min-width': show ? panelContent.width() : null
		// 	})

		// 	this.$('.pagination-test .panel-content .table').toggleClass('is-not-displayed', show)
		// 	this.$('.pagination-test .panel-content .loading-dots').toggleClass('is-not-displayed', !show)
		// }

		// let panelContent = this.$('.pagination-test .panel-content')
		// panelContent.append(loadingDots())

		// let pagination = new Pagination({
		// 	data,
		// 	headerRowTemplate: () => {
		// 		return `
		// 			<tr class="table-row-solid">
		// 				<th>ID</th>
		// 				<th>Title</th>
		// 				<th>Price</th>
		// 				<th>Option</th>
		// 			</tr>`
		// 	},
		// 	// typically, this would be an external .hbs file (ex. see vi-mapping.js)
		// 	rowTemplate: d => {
		// 		// Introduce a 10 option select per row to simulate a DOM intensive
		// 		// situation such as in https://github.com/SpiderStrategies/Scoreboard/issues/33753
		// 		let options
		// 		for (var i = 0; i < 100; i++) {
		// 			options += `<option>${i}</option>`
		// 		}
		// 		let select = '<select>' + options + '</select>'
		// 		return `<tr>
		// 			<td>${d.id}</td>
		// 			<td>${d.title}</td>
		// 			<td>${d.price}</td>
		// 			<td>${select}</td>
		// 		</tr>`
		// 	},
		// 	pageSize: 1000
		// })

		// this.$('.pagination-test').append(pagination.el)
		// pagination.render()
		// // So that this table isn't super duper long, impose a max-height here
		// pagination.$el.find('.panel-content').css({ 'max-height' : 500 })
		// this.on('resize', () => pagination.resize())

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._deleteTooltip, this.alertList], 'remove')
	}
})

export default FormControls
